import { useContext } from "react"
import UpdateLawActContext from "../context/UpdateLawActContext"

const useUpdateLawAct = () => {
    return useContext(UpdateLawActContext);
}

export default useUpdateLawAct